module.exports = __webpack_public_path__ + "img/demographic-targeted.32e5a275.png";